import { useState } from "react"
import { useDispatch } from "react-redux"
import { logout } from "redux/thunks/authorizationThunk"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useToken() {
  const dispatch = useDispatch()

  const getToken = () => {
    const localToken = localStorage.getItem("token")
    const expiryTime = localStorage.getItem("token_expiry")

    if (localToken) {
      const now = new Date().getTime()

      if (expiryTime && now < parseInt(expiryTime)) {
        return localToken
      }

      const logoutAction = logout()
      dispatch(logoutAction)
      // Token expired, clear it
      localStorage.removeItem("token")
      localStorage.removeItem("token_expiry")
    }

    return null
  }

  const [token, setToken] = useState(getToken())

  const saveToken = (userToken, expiresIn = 24 * 60 * 60 * 1000) => {
    const expiryTime = new Date().getTime() + expiresIn

    localStorage.setItem("token", userToken)
    localStorage.setItem("token_expiry", expiryTime.toString())
    setToken(userToken)
  }

  return {
    setToken: saveToken,
    token,
  }
}
